export default __webpack_public_path__ + "e3f774ce7673c21801701260f2d4f572.png";